export default __webpack_public_path__ + "static/media/logo.f878999d.svg";